"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumSelectionRefinementType = void 0;
exports.EnumSelectionRefinementType = {
    Preselect: 'Preselect',
    Freeresponse: 'Freeresponse',
};
//# sourceMappingURL=enum-selection-refinement-type.js.map